import React, { useEffect } from "react";
import tw from "twin.macro";
import { css } from "styled-components/macro"; //eslint-disable-line
import AnimationRevealPage from "helpers/AnimationRevealPage.js";
// import Hero from "components/hero/TwoColumnWithVideo.js";
import Hero from "components/hero/kuvuga-hero/KuvugaTwoColumnWithVideo.js";
import Features from "components/features/ThreeColSimple.js";
import MainFeature from "components/features/TwoColWithButton.js";
import MainFeature2 from "components/features/kuvuga-features/KuvugaTwoColSingleFeatureWithStats2.js";
// import TabGrid from "components/cards/TabCardGrid.js"; // needed for popular categories section
import Testimonial from "components/testimonials/ThreeColumnWithProfileImage.js";
import DownloadApp from "components/cta/KuvugaDownloadApp.js";
import Footer from "components/footers/kuvuga-footers/KuvugaFiveColumnWithInputForm.js";

import chefIconImageSrc from "images/chef-icon.svg";
import celebrationIconImageSrc from "images/celebration-icon.svg";
import shopIconImageSrc from "images/shop-icon.svg";

import { kuvugaPageView } from "utils/customAnalyticsUtils";

const Subheading = tw.span`tracking-wider text-sm font-medium`;
const HighlightedText = tw.span`bg-primary-500 text-gray-100 px-4 transform -skew-x-12 inline-block`;
const HighlightedTextInverse = tw.span`bg-gray-100 text-primary-500 px-4 transform -skew-x-12 inline-block`;
const Description = tw.span`inline-block mt-8`;
const imageCss = tw`rounded-4xl`;

export default () => {
  // custom analytics
  useEffect(() => {
    kuvugaPageView();
  }, []);

  return (
    <AnimationRevealPage>
      {/* <Hero
        heading={
          <>
            Discover & Learn <HighlightedText>Study Your Way.</HighlightedText>
          </>
        }
        description="Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua."
        // imageSrc="https://images.unsplash.com/photo-1504674900247-0877df9cc836?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=768&q=80"
        imageSrc="https://images.unsplash.com/photo-1499750310107-5fef28a66643?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2070&q=80"
        imageCss={imageCss}
        imageDecoratorBlob={true}
        primaryButtonText="Get Started"
        primaryButtonUrl="/learn-play"
        watchVideoButtonText="Watch the Demo"
      />       */}
      <Hero
        heading={
          <>
            Get Started <HighlightedText>Today</HighlightedText>
          </>
        }
        description=""
        // imageSrc="https://images.unsplash.com/photo-1504674900247-0877df9cc836?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=768&q=80"
        imageSrc="https://images.unsplash.com/photo-1499750310107-5fef28a66643?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2070&q=80"
        imageCss={imageCss}
        imageDecoratorBlob={true}
        primaryButtonText="Get Started"
        primaryButtonUrl="/learn-play"
        watchVideoButtonText="Watch the Demo"
      />
      <MainFeature
        subheading={<Subheading>Highly Diversified</Subheading>}
        heading={
          <>
            Basic to Advanced Categories with
            <wbr /> <HighlightedText>over 20 lessons.</HighlightedText>
          </>
        }
        description={
          <Description>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
            eiusmod tempor incididunt ut labore et dolore magna aliqua.
            <br />
            <br />
            Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris
            nisi ut aliquip ex ea commodo consequat.
          </Description>
        }
        buttonRounded={false}
        textOnLeft={false}
        primaryButtonText="Go to Lessons"
        primaryButtonUrl="/lessons"
        imageSrc={
          // "https://images.unsplash.com/photo-1460306855393-0410f61241c7?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=768&q=80"
          "https://images.unsplash.com/photo-1584907797015-7554cd315667?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxzZWFyY2h8Mzd8fGFkdmFuY2VkfGVufDB8fDB8fA%3D%3D&auto=format&fit=crop&w=600&q=60"
        }
        imageCss={imageCss}
        imageDecoratorBlob={true}
        imageDecoratorBlobCss={tw`left-1/2 -translate-x-1/2 md:w-32 md:h-32 opacity-25`}
      />
      {/* TabGrid Component also accepts a tabs prop to customize the tabs and its content directly. Please open the TabGrid component file to see the structure of the tabs props.*/}
      {/* This is where popular categories will reside.*/}
      {/* <TabGrid
        heading={
          <>
            View popular <HighlightedText>categories.</HighlightedText>
          </>
        }
      /> */}
      <Features
        heading={
          <>
            Amazing <HighlightedText>Options.</HighlightedText>
          </>
        }
        cards={[
          {
            imageSrc: shopIconImageSrc,
            title: "20+ Lessons",
            description: "Lorem ipsum donor amet siti ceali placeholder text",
            url: "https://google.com",
          },
          {
            imageSrc: chefIconImageSrc,
            title: "Customizable Games",
            description: "Lorem ipsum donor amet siti ceali placeholder text",
            url: "https://google.com",
          },
          {
            imageSrc: celebrationIconImageSrc,
            title: "Rich Vocabulary",
            description: "Lorem ipsum donor amet siti ceali placeholder text",
            url: "https://google.com",
          },
        ]}
        imageContainerCss={tw`p-2!`}
        imageCss={tw`w-20! h-20!`}
      />
      <MainFeature2
        subheading={<Subheading>A Reputed Platfrom</Subheading>}
        heading={
          <>
            Why <HighlightedText>Learn with Us ?</HighlightedText>
          </>
        }
        statistics={[
          {
            key: "Categories",
            value: "20+",
          },
          {
            key: "Lessons",
            value: "20+",
          },
          {
            key: "Games",
            value: "Unlimited",
          },
        ]}
        primaryButtonText="Get Started"
        primaryButtonUrl="https://google.com"
        imageInsideDiv={false}
        // imageSrc="https://images.unsplash.com/photo-1414235077428-338989a2e8c0?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEzNzI2fQ&auto=format&fit=crop&w=768&q=80"
        imageSrc="https://images.unsplash.com/photo-1600431521340-491eca880813?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxzZWFyY2h8OHx8bGlicmFyeXxlbnwwfHwwfHw%3D&auto=format&fit=crop&w=600&q=60"
        imageCss={Object.assign(tw`bg-cover`, imageCss)}
        imageContainerCss={tw`md:w-1/2 h-auto`}
        imageDecoratorBlob={true}
        imageDecoratorBlobCss={tw`left-1/2 md:w-32 md:h-32 -translate-x-1/2 opacity-25`}
        textOnLeft={true}
      />
      <Testimonial
        subheading=""
        heading={
          <>
            learners <HighlightedText>Love Us.</HighlightedText>
          </>
        }
      />
      <DownloadApp
        text={
          <>
            People around the world will soon be learning using the{" "}
            <HighlightedTextInverse>Kuvuga App.</HighlightedTextInverse>
          </>
        }
      />
      <Footer />
    </AnimationRevealPage>
  );
};
